import React from "reactn";
import "./RequestInfo.css";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import BaseModal from "./baseModal/BaseModal";
import { CONTENT_BLOCK } from "./baseModal/FieldTypes";
import { BLUE_BUTTON, RED_BUTTON, WHITE } from "./baseModal/colours";

class StaffScheduleCheckOutConfirmationModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      users: []
    };
  }

  requestTour = async e => {
    e.preventDefault();
  };

  async staffCheckOut() {
    const ep = `${process.env.REACT_APP_API}/partners/users/schedule/update/${this.props.selectedSchedule.id}`;

    this.setGlobal({ loading: true });

    const results = await axios.post(ep, {
      checked_out: true,
      check_out_date: new Date()
    });

    const ep2 = `${process.env.REACT_APP_API}/partners/users/work-log/check-out/${this.props.selectedStaff.id}`;
    const results2 = await axios.post(ep2, {
      scheduleId: this.props.selectedSchedule.id,
      end_time: new Date()
    });

    if (results2.data.success) {
      toast.success("Successfully Checked-Out!");
      this.props.onRefresh();
      this.props.onClose();
      this.setGlobal({ loading: false });
    } else {
      toast.error("Error while Checking out.");
    }
  }

  getBaseModalFields() {
    const fields = [];

    const checkOutConfirmationField = {
      type: CONTENT_BLOCK,
      data: {
        name: "Are you sure you would like to check-out?"
      }
    };

    fields.push(checkOutConfirmationField);

    return fields;
  }

  getBaseModalButtons = () => {
    const checkOutButton = {
      name: "Confirm",
      buttonColour: BLUE_BUTTON,
      textColour: WHITE,
      validatoryKey: "validateSubmit",
      handleClick: () => this.staffCheckOut()
    };

    return [checkOutButton];
  };

  getBaseModalProps = () => {
    return {
      title: "Schedule Check-Out",
      fields: this.getBaseModalFields(),
      buttons: this.getBaseModalButtons(),
      height: "65vh",
      midSectionHeight: "52vh",
      handleClose: this.props.onClose
    };
  };

  render() {
    return <BaseModal {...this.getBaseModalProps()} />;
  }
}

export default withRouter(StaffScheduleCheckOutConfirmationModal);
